import Vue from 'vue'
import Router from 'vue-router'
import CampaignView from "./views/CampaignView";
import CampaignDialog from "./components/campaignView/CampaignDialog";
import JobView from "./views/JobView";

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/jobs',
            component: JobView
        },
        {
            path: '/',
            name: CampaignView.name,
            component: CampaignView,
            children: [
                {
                    name: 'CreateCampaign',
                    path: 'new',
                    component: CampaignDialog
                },
                {
                    name: 'ShowCampaign',
                    path: ':type/:id',
                    component: CampaignDialog
                }
            ]
        }
    ]
})
